export class Section {
    constructor (public title: string, public route: string)
    {};
}


// WEBPACK FOOTER //
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/models/privatenav-model.ts